import AnalysisView from './component';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { renderHeaderButton } from '../../store/headerButtonControl/duck';

export default injectIntl(
  connect(state => ({ userDetails: state.user.userDetails }), { renderHeaderButton })(AnalysisView)
);
